module.exports = __webpack_public_path__ + "static/media/plan-of-study.7aa74afd.svg";